// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import locale from 'element-ui/lib/locale';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueI18n from 'vue-i18n';
import {createI18n} from 'vue-i18n-bridge';
import i18nConfig from './.i18n-config';
import VueQriously from 'vue-qriously';
import VueCookie from 'vue-cookie'; // VueCookiesに置き換える
import VueCookies from 'vue-cookies';
import { LANG } from '@/const/Lang';
import VueAnalytics from 'vue-analytics';
import VueHead from 'vue-head';
import VueGtm from 'vue-gtm';
import VueGtag from 'vue-gtag';
import VueShepherd from 'vue-shepherd';
import CookieKeys from '@/const/CookieKeys';
import Cookies from 'js-cookie';

// <head>タグ生成用
Vue.use(VueHead);

// ローカライズ言語の設定
Vue.use(VueI18n, { bridge: true });
// https://zenn.dev/longrun_jp/articles/2b6d024c0d6675 を参考に設定
const i18n = createI18n(i18nConfig, VueI18n);
Vue.use(i18n);

// ElementUIの設定
Vue.use(ElementUI);
locale.i18n((key, value) => i18n.t(key, value));

// QRコード生成
Vue.use(VueQriously);

// Cookie VueCookieは削除にバグがあるので、VueCookiesに置き換える
Vue.use(VueCookie);
Vue.use(VueCookies);

// アナリティクス
Vue.use(VueAnalytics, {
  id: 'hoge', // TODO: アナリティクスのID設定
  router
});

// オンボーディングツアーを利用
Vue.use(VueShepherd);

if (process.env.NODE_ENV === 'production') {
  const uri = new URL(window.location.href);
  const originalDomain = Object.values(process.env.ORIGINAL_DOMAIN_LIST).find((domain) => domain.DOMAIN === uri.hostname);
  const siteId = originalDomain ? originalDomain.SID : location.pathname.split('/')[1];
  // Cookie利用許諾を取っているサイトはユーザが許諾した場合のみ計測する
  if (!process.env.REQUIRE_COOKIE_PERMISSION_SITE ||
      !Object.values(process.env.REQUIRE_COOKIE_PERMISSION_SITE).includes(siteId) ||
      Cookies.get(CookieKeys.COOKIE_ACCEPT) === 'true') {
    // GTM
    try {
      const gtmId = process.env.GTM_ID_LIST[siteId];
      if (gtmId !== undefined && gtmId) {
        Vue.use(VueGtm, {
          id: gtmId,
        });
      }
    } catch (e) {
      console.log(e);
    }

    // GA
    try {
      // パッケージ全体のトラッキングコード(NTJ用)
      let options = {
        config: {
          id: 'G-MH4GMD3LE9'
        }
      };
      // クライアント別のトラッキングコード
      const gaId = process.env.GA_ID_LIST[siteId];
      if (gaId !== undefined && gaId) {
        options.includes = [
          {id: gaId}
        ];
      };
      Vue.use(VueGtag, options, router);
    } catch (e) {
      console.log(e);
    }
  }
}

// 追記ここから
Vue.config.productionTip = false;

// 地図スクリプトの非同期読み込み
// コンポーネント側で await window.__mapScriptReady で読み込み完了を待てる
window.__mapScriptReady = new Promise((resolve) => {
  try {
    let pathLang = location.pathname.split('/')[2];
    const uri = new URL(window.location.href);
    const originalDomain = Object.values(process.env.ORIGINAL_DOMAIN_LIST).find((domain) => domain.DOMAIN === uri.hostname);
    if (originalDomain) {
      pathLang = location.pathname.split('/')[1];
    }
    if (pathLang === '' || pathLang === 'static') {
      const langParam = location.search.match(/[?&]lang=[^&]+/i);
      if (langParam !== null && langParam.length > 0) {
        pathLang = langParam[0].split('=').length > 1 ? langParam[0].split('=')[1] : LANG.ja;
      }
    }
    // このアプリは全画面で GaIA SDK を直接利用するため mapscript の読み込みは不要
    resolve(true);
  } catch (e) {
    console.log(e);
    resolve(false);
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: { App },
});
